const removeIdIfNew = item => (item.new ? { ...item, id: undefined } : item);

export function serializeTip(state, fields) {
  const form = new FormData();

  // Adding paragraphs image as file parts
  state.chapters.paragraphs.filter(p => p.imagePartId && p.image).forEach(p => {
    form.append(p.imagePartId, p.image);
  });

  // Diff tree serialized as JSON for easier processing
  const diffAsJson = serializeAsJson(state, fields);
  form.append('diff', diffAsJson);

  // Appending tip image and attachment
  form.append('image', fields.image);
  form.append('attachment', fields.attachment);

  return form;
}

function serializeAsJson(state, fields) {
  const paragraphs = state.chapters.paragraphs
    .map(p => serializeParagraph(p))
    .map(p => removeIdIfNew(p))
    .toArray();

  const paragraphsForChapter = chapter =>
    paragraphs.filter(p => p.chapter.toString() === chapter.toString());

  const chapters = state.chapters.chapters
    .map(c => {
      return {
        ...c,
        paragraphs: paragraphsForChapter(c.id),
      };
    })
    .map(c => removeIdIfNew(c))
    .toArray();

  const { title, image_id, attachmentId, video } = fields;
  const removedChapters = state.history.chapters.toArray();
  const removedParagraphs = state.history.paragraphs.toArray();

  const data = {
    title,
    image_id,
    attachment_id: attachmentId,
    video_url: video && video.length ? video : null,
    chapters,
    removed_chapters: removedChapters,
    removed_paragraphs: removedParagraphs,
  };

  return JSON.stringify(data);
}

function serializeParagraph(paragraph) {
  if (paragraph.content) {
    return paragraph;
  }

  const imageId = paragraph.image ? paragraph.image.id : undefined;

  // Clearing image before serialization
  return {
    ...paragraph,
    image_part_id: paragraph.imagePartId,
    image_id: imageId,
    image: undefined,
    thumbnail: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/modules/tip/utils/serialize.js